export default () => ({
  user: null,
  channels: [],
  mychannels: [],
  requests: [],
  channelInfo: null,
  messages: [],
  membership: null,
  unreadCounts: [],
  unreadCount: 0,
  firmCounts: [],
  chatBar: [],
  handlerId: null,
  changed: null,
  foundMembers: [],
  someoneTyping: null
})



// WEBPACK FOOTER //
// ./src/store/modules/chat/state.js